import { Table } from '@tanstack/react-table';
import { ChevronsDownUp, ChevronsUpDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { SimpleTooltip } from '@/components/ui/simple-tooltip';

interface ExpandAllRowsButtonProps<T> {
  table: Table<T>;
}

/**
 * Header toggle for expandable tables: collapses everything while at least one row is open,
 * otherwise expands every row that can expand.
 */
export function ExpandAllRowsButton<T>({ table }: ExpandAllRowsButtonProps<T>) {
  const { t } = useTranslation('common');
  const isAnyExpanded = table.getIsSomeRowsExpanded();
  const label = isAnyExpanded ? t('generateEntities.collapseAll') : t('generateEntities.expandAll');

  return (
    <SimpleTooltip content={label}>
      <Button
        type="button"
        variant="ghost"
        size="xxs"
        className="shrink-0 text-muted-foreground"
        aria-label={label}
        onClick={event => {
          event.stopPropagation();
          table.toggleAllRowsExpanded(!isAnyExpanded);
        }}
      >
        {isAnyExpanded ? <ChevronsDownUp size={16} /> : <ChevronsUpDown size={16} />}
      </Button>
    </SimpleTooltip>
  );
}
